<h4 class="semi-black title" style="padding-top: 90px;">{{title}}</h4>

<accordion [closeOthers]="true" class="accordionModalProduct">
  <accordion-group *ngFor="let region of infoEventRate; let i = index" class="accordionGroupModalProduct" style="color: black !important" [heading]="region.region" [isOpen]="isTargetRegion(region.region)">

    <div *ngFor="let categoria of region.categorias" class="card mb-4 border-0" [id]="categoriaAnchorId(region.region, categoria.categoria_nombre)">
      <div class="card-header" style="background-color: #f3fdf9;">
        <h5 class="mb-0 " style="color: black !important">{{ categoria.categoria_nombre }}</h5>
      </div>
      <div class="card-body">
        <img [src]="'https://legacy.moebius.tur.ar/verIcono/' + categoria.imagen"
             class="img-fluid mb-3" alt="imagen" style="max-height: 200px;">
        <div *ngFor="let archivo of categoria.archivos" class="mb-3">
          <h6>{{ archivo.display }}</h6>
          <div [innerHTML]="archivo.descripcion"></div>
          <button class="btn btn-outline-primary btn-sm mt-2"
             (click)="getUrlDownload(archivo)" target="_blank">
            Ver archivo
          </button>
        </div>
      </div>
    </div>

  </accordion-group>
</accordion>
